import { UserAccountApi, useAPIQuery } from "melco-shared-logic";

export const useUserProductsData = (userId?: string) => {
  return useAPIQuery(
    UserAccountApi,
    ["accountProductList"],
    async (api) => {
      //const api = new UserAccountApi(baseApiConfig({ token, impersonationForId: userId }));

      //api.defaultsGetReferralList
      const response = await api.accountProductsList();

      return response;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
      apiConfigOptions: {
        impersonationForId: userId ?? "",
      },
    }
  );
};
